import React ,{useEffect,useState,useRef} from 'react';
import Swiper from 'react-id-swiper';
import "./sections.scss";
import {getMallCats_api} from "../../../Services/apis";
import {useHistory} from "react-router-dom";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import {ServiceTags_api, Tags_api} from "../../Service/ServiceServices";

function TagBannerSec({item}) {

    const [tags,setTags] = useState([])
    const history = useHistory()

    const clickOnItem = (item)=>{
        history.push("/services",{tagLink:item})
    }

    useEffect(()=>{
       getTags();
    },[])



    const getTags = async()=>{
        try{
            const res= await Tags_api();
            setTags(res.data)
        }catch (e) {
            console.log("e")
        }
    }

    const goToTag = (tag)=>{
        switch (tag.tag_type) {
            case "service":
                history.push("/services",{tagLink:tag})
                break;
            case "blog_post":
                history.push("/blogs",{tagLink:tag})
                break;
        }
    }

    return(
        <div className="tag-banner-sec" style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="tag-banner-list">
                {tags.map(t=>{
                    return(
                        <div onClick={()=>{
                            goToTag(t)
                        }} className="tag-banner-item"
                             // style={{backgroundImage: `url(${t.image})`}}
                        >
                            {t.name}
                        </div>
                    )
                })}
            </div>
        </div>

    )
}

export default TagBannerSec;
